(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hinomi-sticky-top-bar"] && !Shopify.designMode) return;
  try {
    (() => {

  const setup = (root) => {

    if (root.dataset.hstbReady === 'true') {
      return;
    }


    root.dataset.hstbReady = 'true';



    /*
     * Safe CSS selector helper
     */

    const safeQueryAll = (selector) => {

      try {

        return selector
          ? Array.from(
              document.querySelectorAll(selector)
            )
          : [];

      } catch (error) {

        return [];

      }

    };



    const trigger =
      safeQueryAll(
        root.dataset.triggerSelector
      )[0];



    const links =
      Array.from(
        root.querySelectorAll(
          '.hstb__nav a'
        )
      );



    const pageTopButton =
      root.querySelector(
        '[data-hstb-page-top]'
      );



    const scrollGap =
      Math.max(
        0,
        Number(
          root.dataset.scrollGap
        ) || 0
      );



    const prefersReducedMotion =
      window
        .matchMedia(
          '(prefers-reduced-motion: reduce)'
        )
        .matches;



    /*
     * Resolve navigation target sections
     */

    const targets =
      links.map((link) => {

        try {

          return document.querySelector(
            link.getAttribute('href')
          );

        } catch (error) {

          return null;

        }

      });



    /*
     * Find Shopify sticky header bottom position
     */

    const headerBottom = () => {

      const bottoms =
        safeQueryAll(
          root.dataset.headerSelector
        )
        .map((element) => {

          const rect =
            element.getBoundingClientRect();


          return (
            rect.height > 0 &&
            rect.bottom > 0
          )
            ? Math.min(
                rect.bottom,
                window.innerHeight
              )
            : 0;

        });


      return Math.max(
        0,
        ...bottoms
      );

    };



    /*
     * Offset used by anchor navigation
     */

    const scrollOffset = () =>
      Math.ceil(

        headerBottom() +

        root
          .getBoundingClientRect()
          .height +

        scrollGap

      );



    let frame;



    /*
     * Sticky bar update
     */

    const update = () => {

      cancelAnimationFrame(frame);


      frame =
        requestAnimationFrame(() => {


          const offset =
            Math.round(
              headerBottom()
            );



          /*
           * Show bar after PageFly hero leaves screen
           */

          const passedTrigger =
            trigger

              ? trigger
                  .getBoundingClientRect()
                  .bottom
                  <= offset + 1

              : window.scrollY >
                  window.innerHeight * .7;



          /*
           * Keep sticky bar underneath Shopify header
           */

          root.style.setProperty(
            '--hstb-top',
            `${offset}px`
          );



          /*
           * Visibility
           */

          root.classList.toggle(
            'is-visible',
            passedTrigger
          );


          root.setAttribute(
            'aria-hidden',
            String(!passedTrigger)
          );



          /*
           * Anchor scroll offset
           */

          const marker =
            scrollOffset();


          targets.forEach(
            (target) => {

              if (target) {

                target.style.scrollMarginTop =
                  `${marker}px`;

              }

            }
          );



          /*
           * Active section detection
           */

          let activeIndex = 0;


          targets.forEach(
            (target, index) => {

              if (
                target &&
                target
                  .getBoundingClientRect()
                  .top <= marker
              ) {

                activeIndex =
                  index;

              }

            }
          );



          /*
           * Active navigation state
           */

          links.forEach(
            (link, index) => {

              link.classList.toggle(
                'is-active',
                index === activeIndex
              );

            }
          );



          /*
           * Mobile multilingual navigation:
           * keep active item visible
           */

          if (
            window.innerWidth <= 749 &&
            links[activeIndex]
          ) {

            const activeLink =
              links[activeIndex];


            const nav =
              activeLink.parentElement;


            if (!nav) {
              return;
            }


            const linkRect =
              activeLink.getBoundingClientRect();


            const navRect =
              nav.getBoundingClientRect();



            if (
              linkRect.left <
              navRect.left
            ) {

              nav.scrollBy({

                left:
                  linkRect.left -
                  navRect.left -
                  14,

                behavior:
                  prefersReducedMotion
                    ? 'auto'
                    : 'smooth'

              });

            }



            if (
              linkRect.right >
              navRect.right
            ) {

              nav.scrollBy({

                left:
                  linkRect.right -
                  navRect.right +
                  14,

                behavior:
                  prefersReducedMotion
                    ? 'auto'
                    : 'smooth'

              });

            }

          }

        });

    };



    /*
     * Smooth section navigation
     */

    links.forEach(
      (link, index) => {

        link.addEventListener(
          'click',
          (event) => {


            const target =
              targets[index];


            if (!target) {
              return;
            }


            event.preventDefault();



            const top =
              window.scrollY +

              target
                .getBoundingClientRect()
                .top -

              scrollOffset();



            window.scrollTo({

              top,

              behavior:
                prefersReducedMotion
                  ? 'auto'
                  : 'smooth'

            });

          }
        );

      }
    );



    /*
     * Scroll back to page top
     */

    if (pageTopButton) {

      pageTopButton.addEventListener(
        'click',
        (event) => {


          event.preventDefault();

          event.stopPropagation();



          window.scrollTo({

            top: 0,

            left: 0,

            behavior:
              prefersReducedMotion
                ? 'auto'
                : 'smooth'

          });

        }
      );

    }



    /*
     * Global listeners
     */

    window.addEventListener(
      'scroll',
      update,
      {
        passive: true
      }
    );


    window.addEventListener(
      'resize',
      update,
      {
        passive: true
      }
    );



    /*
     * Resize observer
     */

    if (window.ResizeObserver) {

      const observer =
        new ResizeObserver(
          update
        );


      observer.observe(root);



      if (trigger) {

        observer.observe(
          trigger
        );

      }



      safeQueryAll(
        root.dataset.headerSelector
      )
      .forEach(
        (header) => {

          observer.observe(
            header
          );

        }
      );

    }



    /*
     * Initial update
     */

    update();



    /*
     * PageFly/theme elements may shift
     * after initial render.
     */

    window.setTimeout(
      update,
      500
    );

  };



  /*
   * Initialize all sticky bars
   */

  const initialize = () => {

    document
      .querySelectorAll(
        '[data-hstb]'
      )
      .forEach(
        setup
      );

  };



  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      {
        once: true
      }
    );

  } else {

    initialize();

  }

})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["listing-assets"] && !Shopify.designMode) return;
  try {
    /* Idempotent listing controllers, including Shopify theme-editor lifecycle. */
(() => {
  if (window.HinomiListing) return;
  const controllers = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function mount(root) {
    if (controllers.has(root)) return;
    const abort = new AbortController();
    const listeners = { signal: abort.signal };
    const observers = [];
    root.querySelectorAll('[data-listing-hover-pair]').forEach(pair => {
      const [photo, motion] = pair.children;
      if (!photo || !motion) return;
      const desktop = matchMedia('(min-width:1024px) and (hover:hover) and (pointer:fine)');
      let active = false;
      const pause = () => motion.querySelector('video')?.pause();
      function reset() {
        active = false;
        pair.classList.remove('is-motion-active');
        pause();
      }
      function expand() {
        if (!desktop.matches) return;
        active = true;
        pair.classList.add('is-motion-active');
        const video = motion.querySelector('video');
        if (!video || reduced.matches) return;
        video.muted = true;
        video.playsInline = true;
        video.play()?.then(() => { if (!active) video.pause(); }).catch(() => {});
      }
      // Keep the original wide image height while the columns exchange widths.
      let previousWidth = -1;
      const resize = new ResizeObserver(() => {
        const width = pair.getBoundingClientRect().width;
        if (width === previousWidth) return;
        previousWidth = width;
        const gap = parseFloat(getComputedStyle(pair).columnGap) || 0;
        pair.style.setProperty('--listing-pair-height', `${(width - gap) * 6 / 11}px`);
      });
      resize.observe(pair);
      motion.addEventListener('pointerenter', expand, listeners);
      photo.addEventListener('pointerenter', reset, listeners);
      pair.addEventListener('pointerleave', reset, listeners);
      motion.addEventListener('focusin', expand, listeners);
      pair.addEventListener('focusout', event => {
        if (!motion.contains(event.relatedTarget)) reset();
      }, listeners);
      desktop.addEventListener('change', reset, listeners);
      reduced.addEventListener('change', reset, listeners);
      document.addEventListener('visibilitychange', () => { if (document.hidden) reset(); }, listeners);
      const visibility = new IntersectionObserver(entries => {
        if (!entries[0].isIntersecting) reset();
      });
      visibility.observe(pair);
      observers.push(resize, visibility, { disconnect: reset });
    });
    root.querySelectorAll('.listing-highlights-grid').forEach(grid => {
      const cards = [...grid.children];
      if (!cards.length || typeof IntersectionObserver !== 'function' || reduced.matches) return;
      grid.classList.add('listing-reveal-ready');
      cards.forEach((card, i) => card.style.setProperty('--listing-reveal-delay', `${Math.min(i, 5) * 70}ms`));
      const reveal = card => card.classList.add('is-revealed');
      const observer = new IntersectionObserver((entries, io) => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        io.unobserve(entry.target);
      }), { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
      cards.forEach(card => observer.observe(card));
      reduced.addEventListener('change', () => {
        if (!reduced.matches) return;
        cards.forEach(reveal);
        grid.classList.remove('listing-reveal-ready');
      }, listeners);
      observers.push(observer);
    });
    root.querySelectorAll('[data-listing-carousel]').forEach(carousel => {
      const track = carousel.querySelector('[data-track]');
      if (!track) return;
      const slides = [...track.children];
      if (!slides.length) return;
      const prev = carousel.querySelector('[data-prev]');
      const next = carousel.querySelector('[data-next]');
      const status = carousel.querySelector('[data-status]');
      const dots = [...carousel.querySelectorAll('[data-slide-to]')];
      const position = i => Math.max(0, Math.min(slides[i].offsetLeft - slides[0].offsetLeft, track.scrollWidth - track.clientWidth));
      let index = 0;
      let frame = 0;
      function snapPositions() {
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        const positions = slides.map((slide, i) => slide.offsetLeft - slides[0].offsetLeft)
          .filter(value => value < max - 2);
        if (!positions.length || positions[positions.length - 1] !== max) positions.push(max);
        return [...new Set(positions.map(value => Math.max(0, Math.min(max, value))))];
      }
      function update() {
        frame = 0;
        const max = track.scrollWidth - track.clientWidth;
        index = slides.reduce((best, _, i) => Math.abs(position(i) - track.scrollLeft) < Math.abs(position(best) - track.scrollLeft) ? i : best, 0);
        if (track.scrollLeft >= max - 2 && max > 0) index = slides.length - 1;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
        if (status) status.textContent = `${index + 1} / ${slides.length}`;
        dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
      }
      function go(i) {
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        const positions = snapPositions();
        const target = i <= 0 ? 0 : i >= slides.length - 1 ? max : positions[Math.min(i, positions.length - 1)] ?? max;
        track.scrollTo({ left: target, behavior: reduced.matches ? 'instant' : 'smooth' });
      }
      function move(direction) {
        const current = track.scrollLeft;
        const positions = snapPositions();
        const target = direction < 0
          ? positions.filter(value => value < current - 2).pop() ?? 0
          : positions.find(value => value > current + 2) ?? positions[positions.length - 1] ?? 0;
        track.scrollTo({ left: target, behavior: reduced.matches ? 'instant' : 'smooth' });
      }
      prev.addEventListener('click', () => move(-1), listeners);
      next.addEventListener('click', () => move(1), listeners);
      dots.forEach((dot, i) => dot.addEventListener('click', () => go(i), listeners));
      track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') go(0);
        else if (event.key === 'End') go(slides.length - 1);
        else move(event.key === 'ArrowRight' ? 1 : -1);
      }, listeners);
      track.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, { ...listeners, passive: true });
      const resize = new ResizeObserver(update);
      resize.observe(track);
      observers.push(resize, { disconnect: () => cancelAnimationFrame(frame) });
      if (carousel.dataset.mobileStart && matchMedia('(max-width:767px)').matches) {
        track.scrollLeft = position(Number(carousel.dataset.mobileStart));
      }
      update();
      if (carousel.hasAttribute('data-listing-cycle')) {
        let visible = false;
        let hovering = false;
        let timer;
        const stop = () => clearTimeout(timer);
        const schedule = () => {
          stop();
          if (!visible || hovering || document.hidden || reduced.matches || carousel.contains(document.activeElement)) return;
          timer = setTimeout(() => {
            const max = track.scrollWidth - track.clientWidth;
            if (track.scrollLeft >= max - 2) go(0); else move(1);
            schedule();
          }, 5000);
        };
        const visibility = new IntersectionObserver(entries => {
          visible = entries[0].intersectionRatio >= .5;
          schedule();
        }, { threshold: [0, .5] });
        visibility.observe(carousel);
        carousel.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovering = true; stop(); } }, listeners);
        carousel.addEventListener('pointerleave', () => { hovering = false; schedule(); }, listeners);
        carousel.addEventListener('focusin', stop, listeners);
        carousel.addEventListener('focusout', () => queueMicrotask(schedule), listeners);
        carousel.addEventListener('pointerdown', stop, listeners);
        carousel.addEventListener('pointerup', schedule, listeners);
        document.addEventListener('visibilitychange', schedule, listeners);
        reduced.addEventListener('change', schedule, listeners);
        observers.push(visibility, { disconnect: stop });
      }
    });
    root.querySelectorAll('video').forEach(video => {
      const mobile = matchMedia('(max-width:767px)');
      const shouldAutoPlay = () => video.matches('[data-listing-autoplay]') || (mobile.matches && video.matches('[data-listing-mobile-autoplay]'));
      const io = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!shouldAutoPlay()) return;
        if (entry.intersectionRatio >= .5 && !reduced.matches) video.play().catch(() => {});
        else video.pause();
      }), { threshold: [0, .5] });
      io.observe(video);
      observers.push(io);
      mobile.addEventListener('change', () => { if (!shouldAutoPlay()) video.pause(); }, listeners);
      video.addEventListener('error', () => video.closest('.listing-media')?.classList.add('is-video-error'), listeners);
      if (reduced.matches) { video.autoplay = false; video.pause(); }
    });
    controllers.set(root, () => { abort.abort(); observers.forEach(o => o.disconnect()); });
  }
  function roots(scope) {
    return [...(scope.matches?.('.listing-root') ? [scope] : []), ...scope.querySelectorAll('.listing-root')];
  }
  const init = (scope = document) => roots(scope).forEach(mount);
  const destroy = scope => roots(scope).forEach(root => { controllers.get(root)?.(); controllers.delete(root); });
  window.HinomiListing = { init, destroy };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => destroy(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["listing-sticky-bar"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('listing-sticky-bar')) return;

    customElements.define('listing-sticky-bar', class extends HTMLElement {
      connectedCallback() {
        if (this.relocating || this.controller) return;
        const json = this.querySelector('[data-variants]');
        if (!json) return;
        if (this.parentElement !== document.body) {
          // Escape listing sections' isolated stacking contexts; keep their editor owner.
          this.sourceSection = this.closest('.shopify-section') || this.closest('section');
          this.sourceAnchor = document.createComment('listing-sticky-bar');
          this.before(this.sourceAnchor);
          this.relocating = true;
          document.body.appendChild(this);
          this.relocating = false;
        }
        this.variants = new Map(JSON.parse(json.textContent).map(variant => [String(variant.id), variant]));
        this.price = this.querySelector('[data-price]');
        this.compare = this.querySelector('[data-compare]');
        this.button = this.querySelector('[data-buy]');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.refresh = () => {
          this.findElements();
          this.subscribeToVariants();
          this.syncVariant(true);
          this.queueLayout();
        };
        this.button.addEventListener('click', () => this.returnToBuyBox(), options);
        document.addEventListener('change', event => {
          if (!this.mainProduct?.contains(event.target)) return;
          if (!event.target.matches('[name="id"]') && !event.target.closest('variant-selects, variant-radios')) return;
          // Dawn dispatches the hidden ID change before its price response arrives.
          queueMicrotask(() => { if (this.controller) this.syncVariant(); });
        }, options);
        document.addEventListener('shopify:section:load', this.refresh, options);
        document.addEventListener('shopify:section:unload', event => {
          if (event.target === this.sourceSection || (this.sourceAnchor && event.target.contains(this.sourceAnchor))) {
            this.remove();
            return;
          }
          queueMicrotask(() => { if (this.controller) this.refresh(); });
        }, options);
        document.addEventListener('DOMContentLoaded', this.refresh, options);
        window.addEventListener('scroll', () => this.queueLayout(), { ...options, passive: true });
        window.addEventListener('resize', () => this.queueLayout(), options);
        this.hidden = false;
        this.refresh();
      }

      disconnectedCallback() {
        if (this.relocating) return;
        this.controller?.abort();
        this.controller = null;
        this.unsubscribe?.();
        this.unsubscribe = null;
        this.resizeObserver?.disconnect();
        this.headerObserver?.disconnect();
        if (this.layoutFrame) cancelAnimationFrame(this.layoutFrame);
        this.layoutFrame = 0;
        this.classList.remove('is-shown');
        this.setAttribute('aria-hidden', 'true');
        this.hidden = true;
        this.sourceAnchor?.remove();
        this.sourceAnchor = null;
        this.sourceSection = null;
      }

      findElements() {
        this.mainProduct = [...document.querySelectorAll('[id^="MainProduct-"]')].find(root => {
          const input = root.querySelector('product-form form[action*="/cart/add"] [name="id"]');
          return input && this.variants.has(String(input.value));
        });
        this.form = this.mainProduct?.querySelector('product-form form[action*="/cart/add"]');
        this.picker = this.mainProduct?.querySelector('variant-selects, variant-radios');
        this.trigger = document.getElementById(this.dataset.targetId);
        if (!this.trigger && this.dataset.targetId === 'listing-highlights') {
          this.trigger = document.querySelector('[id$="__listing_highlights"]') ||
            document.querySelector('.listing-highlights-grid')?.closest('.listing-root');
        }
        const header = document.querySelector('.section-header') || document.querySelector('sticky-header');
        if (header === this.header && this.resizeObserver) return;
        this.header = header;
        this.resizeObserver?.disconnect();
        this.headerObserver?.disconnect();
        this.resizeObserver = new ResizeObserver(() => this.queueLayout());
        this.resizeObserver.observe(this);
        if (header) {
          this.resizeObserver.observe(header);
          // Dawn reveals and hides the header by changing these classes.
          this.headerObserver = new MutationObserver(() => this.queueLayout());
          this.headerObserver.observe(header, { attributes: true, attributeFilter: ['class', 'style'] });
        }
      }

      subscribeToVariants() {
        if (this.unsubscribe || typeof subscribe !== 'function' || !window.PUB_SUB_EVENTS?.variantChange) return;
        this.unsubscribe = subscribe(window.PUB_SUB_EVENTS.variantChange, event => {
          const data = event?.data;
          const sectionId = this.mainProduct?.dataset.section;
          const originalId = this.picker?.dataset.originalSection;
          if (!data || !sectionId || ![sectionId, originalId].includes(String(data.sectionId))) return;
          // Ignore an older response if the visitor has already chosen another variant.
          if (String(data.variant?.id) !== String(this.form?.querySelector('[name="id"]')?.value)) return;
          this.syncVariant(true);
        });
      }

      syncVariant(checkNative = false) {
        const invalidSelection = this.picker && Object.prototype.hasOwnProperty.call(this.picker, 'currentVariant') && !this.picker.currentVariant;
        const id = this.form?.querySelector('[name="id"]')?.value || this.dataset.initialVariant;
        const variant = invalidSelection ? null : this.variants.get(String(id));
        const addButton = this.form?.querySelector('[name="add"]');
        const available = Boolean(variant?.available) && (!checkNative || !addButton?.disabled);
        this.price.textContent = variant?.price_money || '';
        this.price.hidden = !variant;
        this.compare.textContent = variant?.compare_price_money || '';
        this.compare.hidden = !variant?.compare_price_money;
        this.button.disabled = !available;
        this.button.textContent = available ? this.dataset.buyLabel :
          variant ? this.dataset.soldOutLabel : this.dataset.unavailableLabel;
      }

      headerOffset(anticipateReveal = false) {
        if (!this.header) return 0;
        const style = getComputedStyle(this.header);
        const sticky = ['fixed', 'sticky'].includes(style.position) || this.header.classList.contains('shopify-section-header-sticky');
        if (!sticky) return 0;
        if (!anticipateReveal && this.header.classList.contains('shopify-section-header-hidden')) return 0;
        const rect = this.header.getBoundingClientRect();
        return Math.round(rect.height + Math.max(0, rect.top));
      }

      queueLayout() {
        if (this.layoutFrame || !this.controller) return;
        this.layoutFrame = requestAnimationFrame(() => {
          this.layoutFrame = 0;
          this.style.setProperty('--listing-sticky-top', `${this.headerOffset()}px`);
          const shown = Boolean(this.mainProduct?.isConnected && this.trigger?.isConnected &&
            this.trigger.getBoundingClientRect().top < window.innerHeight * .5);
          this.classList.toggle('is-shown', shown);
          this.setAttribute('aria-hidden', String(!shown));
          this.inert = !shown;
        });
      }

      returnToBuyBox() {
        if (!this.mainProduct?.isConnected || this.button.disabled) return;
        const destination = this.mainProduct.querySelector('product-info') || this.mainProduct;
        const top = destination.getBoundingClientRect().top + window.scrollY - this.headerOffset(true) - 20;
        window.scrollTo({ top: Math.max(0, top), behavior: this.reduce.matches ? 'auto' : 'smooth' });
        const control = destination.querySelector('variant-selects select, variant-radios input:checked, [name="add"]:not(:disabled)');
        control?.focus({ preventScroll: true });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
